import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';

@Component({
  name: 'bpc-button-group',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class ButtonGroup extends mixins(AbstractField) {
  @Prop([Object]) readonly value: Record<string, any>;
  @Prop(Array) readonly options: object[];

  get model(): Record<string, any> {
    return this.value;
  }
  set model(val: Record<string, any>) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }
  get count(): number {
    let count = 0;
    this.options.forEach(option => {
      if (this.model[option['value']]) {
        count++;
      }
    });
    return count;
  }

  get days() {
    const days = [];
    this.options.forEach(item => {
      days.push({ text: this.$t(item['text']), value: item['value'] });
    });
    return days;
  }

  get selected() {
    return Object.keys(this.model).filter(day => {
      return this.model[day];
    });
  }

  set selected(values) {
    Object.keys(this.model).forEach(day => {
      this.model[day] = values.includes(day);
    });
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event);
      });
    }
  }

  // onEnterKey() {
  //   this.$emit('enter-key');
  // }

  // updated () { }

  // destroyed () { }
}
